/* eslint-disable @typescript-eslint/no-explicit-any -- DIRECT-239681 */

import { MigrationManifest, PersistState, StateReconciler } from 'redux-persist';
import { PersistMigrate as OriginalPersistMigrate } from 'redux-persist/es/types';

export interface PersistentSliceInternals {
    _persist?: {
        version: number;
        rehydrated: boolean;
    };
}

/**
 * Поля стейта persistent-слайса, которые попадают в storage.
 */
export const PERSISTED_FIELDS: Array<'persistentData' | '_backups'> = ['persistentData', '_backups'];

/**
 * Стейт persistent-слайса в том виде, в каком его хранит storage:
 * поля из `PERSISTED_FIELDS` и `_persist`.
 */
export type StoredPersistState = {
    persistentData?: unknown;
    _backups?: unknown;
    _persist: PersistState;
};

/**
 * Ре-экспорт типов из redux-persist для типизации параметров persist.
 */
export type PersistStorage = {
    getItem(key: string): Promise<any>;
    setItem(key: string, value: any): Promise<void>;
    removeItem(key: string): Promise<void>;
};
export type PersistMigrate = OriginalPersistMigrate;
export type PersistStateReconciler<S> = StateReconciler<S>;
export type PersistMigrationManifest = MigrationManifest;
